<template>
  <form @submit.prevent="handleFileUpload" id="ExcelFileUploadForm">
    <h4 class="mb-4">{{ 'API_TO_AFD_MAPPING' | translate }}</h4>
    <div class="form-group" id="SchemaDefinitionTableAddEditDialog-formGroup-Omschrijving">
      <label>{{ 'SELECT_EXCEL_FILE' | translate() }} <span class="asterisk">*</span></label>
      <div class="custom-file" id="SchemaDefinitionTableAddEditDialog-formGroup-CustomFile">
        <input ref="fileInput" type="file" accept=".xls, .xlsx" class="custom-file-input" id="import_file" name="import_file"
          @change="onFileChange" required>
        <label class="custom-file-label" for="import_file">
          {{ (selectedFile && selectedFile.name) ? selectedFile.name : 'UPLOAD_FILE' | translate }}
        </label>
      </div>
    </div>
    <div class="mt-4 text-right" id="ExcelFileUploadForm-formGroup-buttons">
      <button class="btn btn-link" type="button" @click="emitClose" id="ExcelFileUploadForm-closeButton">{{ 'CLOSE' | translate }}</button>
      <button class="btn btn-primary" type="submit" id="ExcelFileUploadForm-uploadButton">{{ 'ADD' | translate }}</button>
    </div>
  </form>
</template>

<script>
export default {
  data() {
    return {
      selectedFile: null
    };
  },
  methods: {
    onFileChange(event) {
      this.selectedFile = event.target.files[0];
    },
    handleFileUpload() {
      if (this.selectedFile) {
        this.$emit('file-upload', this.selectedFile);
        this.resetFileInput();
      }
    },
    emitClose() {
      this.$emit('close');
      this.resetFileInput();
    },
    resetFileInput() {
      this.selectedFile = null;
      this.$refs.fileInput.value = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.asterisk {
  color: $danger;
}
.form-control {
  padding: 1%;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/mapping/MappingExcelDialog.vue